import { render, staticRenderFns } from "./WorkIconUser.vue?vue&type=template&id=0f785e32"
import script from "./WorkIconUser.vue?vue&type=script&lang=js"
export * from "./WorkIconUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports